import { Company } from '../../../types/company/Company'
import { SourceMapPayload } from '../types'
import { SiblingDecision } from './buildSiblingDecision'
import { buildSourceMapIdentifiers } from './sourceMapPayload'

// Flattens the wizard's per-sibling decisions into the flat list of source maps to create for the
// target company - one payload per forwarded customer/supplier record. Pure, so it can be tested
// without touching the network.
export const collectSourceMapPayloads = (
  target: Company,
  selectedSiblings: Company[],
  decisions: Map<string, SiblingDecision>
): SourceMapPayload[] => {
  const payloads: SourceMapPayload[] = []

  const forward = (siblingId: string, sourceEntity: 'Customer' | 'Supplier', sourceId: string) => {
    payloads.push({
      companyId: target.id,
      source: 'FINADECK',
      localEntity: 'Company',
      sourceEntity,
      identifiers: buildSourceMapIdentifiers(siblingId, sourceId)
    })
  }

  selectedSiblings.forEach(sibling => {
    const decision = decisions.get(sibling.id)
    decision?.forwardCustomer.forEach(sourceId => forward(sibling.id, 'Customer', sourceId))
    decision?.forwardSupplier.forEach(sourceId => forward(sibling.id, 'Supplier', sourceId))
  })

  return payloads
}
